module.exports = __webpack_public_path__ + "img/4_3_m.28465c3d.jpg";